
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { COMPANY_LIST } from "@/constant";
import {
  createCustomerWhole,
  searchCustomer
} from "@/api/customer";
import {
  getPiCombinedUnit,
  getSupplierProduct,
  putPiCombinedUnit
} from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";
import { putPurchaseOrder } from "@/api/credit-note"
import { putUnitPrice } from "@/api/purchase-order"

@Component({
  name: "ModifyDiscounts",
  components: {
    CreateClaim: () => import("../CreateClaim.vue"),
  }
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "索赔金额抵扣" }) private title: "";
  @Prop({ default: "" }) private supplierId: "";
  @Prop({ default: "" }) private relationDocumentId: "";
  @Prop({ default: "" }) private hqCode: "";
  @Prop({ default: {} }) private selectedItem: {};
  @Prop({ default: [] }) private purchaseOrderInfoIdsOfSP: [];
  @Prop({ default: {} }) private deductionInfo: any;

  @Watch("show", { immediate: true })
  private async watchData() {
    if ((this.selectedItem as any).id && this.show) {
      this.form = deepClone(this.selectedItem);
    }
  }

  private form = {} as any;
  private infoFields = [
    {
      label: "未抵扣索赔",
      prop: "unDeductedClaims",
      key: "unDeductedClaims",
      show: true,
      disabled: false
    },
    {
      label: "供应商预定抵扣",
      prop: "reserveDeduction",
      key: "reserveDeduction",
      show: true,
      disabled: false
    },
    {
      label: "未抵扣总金额",
      prop: "unDeductedAmount",
      key: "unDeductedAmount",
      show: true,
      disabled: true,
      type: 'inputNumber',
      precision: 4
    },
    {
      label: "待抵扣总金额",
      prop: "toDeductedAmount",
      key: "toDeductedAmount",
      show: true,
      disabled: false
    },
    {
      label: "采购订单预定抵扣",
      prop: "purchaseOrderDeductionAmount",
      key: "purchaseOrderDeductionAmount",
      show: true,
      disabled: false
    }
  ] as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
    list2: [] as any[]
  };
  public tableCol = [
    {
      label: "S/N",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "索赔单号",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "索赔单金额",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "本次抵扣",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "索赔单剩余金额",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "抵扣",
          code: '',
          click: "handleEdit"
        },
        {
          name: "移除",
          code: '',
          click: "handleDelete",
          type: "delete"
        }
      ],
      show: true,
      disabled: false,
      width: 200
    }
  ];
  public tableCol2 = [
    {
      label: "S/N",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "HQ交易号码",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "询价参照号",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "折后单价",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "抵扣产品数量",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "抵扣总金额",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "索赔单号",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "移除",
          code: '',
          click: "handleDelete",
          type: "delete"
        },
        {
          name: "重置",
          code: '',
          click: "handleEdit"
        }
      ],
      show: true,
      disabled: false,
      width: 200
    },
    {
      label: "尾差",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "选择",
          click: "handleEdit",
          key: "template",
          value: false
        },
        {
          name: "取消",
          click: "handleCancel",
          key: "template",
          color: "color-red",
          value: true
        }
      ],
      show: true,
      disabled: false
    }
  ];

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async submitForm(): Promise<void> {
    let claimTable = (this.$refs.createClaim as any).table.list;
    let allAmount = 0
    claimTable.map(item => {
      allAmount = allAmount + item.deductionAmount
    })
    if(allAmount !== parseFloat(this.deductionInfo.toDeductedAmount + this.deductionInfo.purchaseOrderDeductionAmount)) {
      this.$notify({
        title: "提示",
        message: "索赔单据抵扣金额输入错误，相加应为上方抵扣信息中的待抵扣总金额+采购订单预定抵扣",
        type: "error",
        duration: 2000
      });
      return;
    }
    this.$confirm("是否确定索赔抵扣", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
       await this.saveClaimTable();
       this.$emit('submitForm')
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private onSelectionChange(rows: any[]) {
    console.log(rows);
  }

  public async handleDelete(scope) {
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000
    });
  }

  private async saveClaimTable() {
    let claimTable = (this.$refs.createClaim as any).table.list;
    let claimDeductionReqList = claimTable.map(item => {
      return {
        claimFormId: item.id,
        deductionAmount: item.deductionAmount || 0,
        remark: item.remark || ''
      };
    });
    let data = {
      relationDocumentId: this.relationDocumentId,
      relationDocumentCode: this.hqCode,
      relationDocumentType: "PURCHASE_ORDER",
      purchaseOrderInfoIds: this.purchaseOrderInfoIdsOfSP,
      claimDeductionReqList
    }
    try {
      await putPurchaseOrder(data);
      await putUnitPrice(this.purchaseOrderInfoIdsOfSP);
      this.$notify({
        title: "成功",
        message: "索赔单据保存成功",
        type: "success",
        duration: 2000
      });
    } catch {
      this.$notify({
        title: "失败",
        message: "索赔单据保存失败",
        type: "error",
        duration: 2000
      });
    }
  }


  // 更新组合单位
  private async putPiCombinedUnit() {
    const {
      hqProductName,
      supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit
    } = this.form;
    let params = {
      hqProductName,
      supplierAbbr: supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit
    };
    try {
      await putPiCombinedUnit(this.form.id, params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }

  private handleSuccess() {
    this.close()
  }

  private async getPiCombinedUnit() {
    const res: any = await getPiCombinedUnit(this.form.id);
    this.getSupplierProduct(res.supplierId);
  }

  private async getSupplierProduct(supplierId) {
    const res: any = await getSupplierProduct(supplierId, {
      hqProductName: this.form.hqProductName
    });
    this.$set(this.form, "shipmentChineseUnit", res.chineseUnit || "");
    this.$set(this.form, "shipmentEnglishUnit", res.englishUnit || "");
    this.$set(this.form, "shipmentQuantity", 1);
    this.$set(this.form, "deliveryQuantity", 1);
  }
}
